import { Dateable, RelativeTime } from "@zapier/date-am";
import { BetaDataTableCell as Cell, Text } from "@zapier/design-system";
import styles from "../Table.module.css";

interface DateCellProps {
  /**
   * Tri-state value for the cell:
   * - a date/timestamp → rendered as relative time (e.g. "3 minutes ago")
   * - `null` → known-empty: the value was loaded and there is none → renders `emptyLabel`
   * - `undefined` → unknown: not loaded / not applicable → renders a blank cell
   */
  datetime: Dateable | string | null | undefined;
  /**
   * Shown only in the known-empty state (`datetime === null`); e.g. the Last-run
   * column uses it for "no run in the last 60 days".
   */
  emptyLabel?: string;
}

const DateCell = ({ datetime, emptyLabel }: DateCellProps) => {
  if (!datetime) {
    return (
      <Cell className={styles.lastModifiedColumn}>
        {datetime === null && emptyLabel && (
          <Text type="Body1" color="TextWeaker">
            {emptyLabel}
          </Text>
        )}
      </Cell>
    );
  }
  const date = new Date(datetime);
  return (
    <Cell className={styles.lastModifiedColumn}>
      <Text type="Body1">
        <RelativeTime date={date} />
      </Text>
    </Cell>
  );
};

export default DateCell;
